import { useState } from 'react'
import type { EstadoModuloPlan, ElementoModulo } from './tipos'
import { CampoPesos } from './CampoPesos'
import { useBancoApus } from './apus/useBancoApus'
import estilos from './PlanProyectos.module.css'

type Props = {
  codigoSugerido: string
  onGuardar: (modulo: {
    codigo: string
    nombre: string
    descripcion?: string
    unidad: string
    cantidad: number
    valor_total: number
    horas: number
    estado: EstadoModuloPlan
    apu_id?: string | null
    elementos?: ElementoModulo[]
  }) => void
  onCancelar: () => void
}

export function TarjetaNuevoModuloInline({
  codigoSugerido,
  onGuardar,
  onCancelar,
}: Props) {
  const { apus } = useBancoApus()
  const [apuId, setApuId] = useState('')
  const [codigo, setCodigo] = useState(codigoSugerido)
  const [nombre, setNombre] = useState('')
  const [unidad, setUnidad] = useState('UND')
  const [cantidad, setCantidad] = useState(1)
  const [horas, setHoras] = useState(8)
  const [valorTotal, setValorTotal] = useState(0)

  function handleSeleccionarApu(id: string) {
    setApuId(id)
    const encontrado = apus.find((a) => a.id === id)
    if (encontrado) {
      setCodigo(encontrado.codigo)
      setNombre(encontrado.nombre)
      setUnidad(encontrado.unidad)
      const cant = Number(cantidad) || 1
      setHoras(Math.round(encontrado.horas_hombre_unidad * cant) || 4)
      setValorTotal(Math.round(encontrado.precio_unitario_total * cant))
    }
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!nombre.trim()) return

    const encontrado = apus.find((a) => a.id === apuId)
    const elementosImportados: ElementoModulo[] | undefined = encontrado?.materiales?.map((m) => ({
      id: crypto.randomUUID(),
      tipo: 'material' as const,
      codigo: m.codigo,
      id_inventario: m.id_inventario,
      descripcion: m.descripcion,
      unidad: m.unidad,
      cantidad: Number((m.cantidad * (Number(cantidad) || 1)).toFixed(2)),
    }))

    onGuardar({
      codigo: codigo.trim() || codigoSugerido,
      nombre: nombre.trim(),
      unidad: unidad.trim() || 'UND',
      cantidad: Number(cantidad) || 1,
      horas: Math.round(Number(horas)) || 4,
      valor_total: Number(valorTotal) || 0,
      estado: 'pendiente',
      apu_id: apuId || null,
      elementos: elementosImportados && elementosImportados.length > 0 ? elementosImportados : undefined,
    })
  }

  return (
    <form onSubmit={handleSubmit} className={estilos.tarjetaNuevoModuloInline}>
      {/* Selector Rápido de APU Maestro */}
      <div style={{ marginBottom: '8px' }}>
        <select
          value={apuId}
          onChange={(e) => handleSeleccionarApu(e.target.value)}
          style={{ width: '100%', padding: '5px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '11.5px', fontWeight: 600, background: '#f8fafc' }}
        >
          <option value="">-- Cargar desde Banco de APUs (Opcional) --</option>
          {apus.map((a) => (
            <option key={a.id} value={a.id}>
              {a.codigo} - {a.nombre}
            </option>
          ))}
        </select>
      </div>

      <header className={estilos.moduloHeader}>
        <div className={estilos.moduloHeaderIzq}>
          <input
            type="text"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            className={estilos.inputCodigoInline}
            placeholder="Código"
          />
          <input
            type="number"
            min="0.1"
            step="any"
            value={cantidad}
            onChange={(e) => setCantidad(Number(e.target.value))}
            className={estilos.inputCantidadInline}
            placeholder="Cant"
            title="Cantidad"
          />
          <input
            type="text"
            value={unidad}
            onChange={(e) => setUnidad(e.target.value)}
            className={estilos.inputUnidadInline}
            placeholder="Unidad"
            title="Unidad"
          />
        </div>
        <span className={estilos.badgeNuevoModulo}>+ Nuevo Ítem</span>
      </header>

      <textarea
        autoFocus
        required
        rows={2}
        placeholder="Descripción o tarea del módulo *"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        className={estilos.textareaNombreInline}
      />

      <div className={estilos.filaValoresEdicion}>
        <label>
          <span>COP</span>
          <CampoPesos
            valor={valorTotal}
            onCambio={setValorTotal}
            className={estilos.inputValorInline}
            title="Valor del módulo en COP"
          />
        </label>
        <label>
          <span>Horas</span>
          <input
            type="number"
            min="1"
            value={horas}
            onChange={(e) => setHoras(Number(e.target.value))}
            className={estilos.inputHorasInline}
          />
        </label>
      </div>

      <div className={estilos.accionesNuevoInline}>
        <button
          type="button"
          className={estilos.btnCancelarInline}
          onClick={onCancelar}
        >
          Cancelar
        </button>
        <button type="submit" className={estilos.btnGuardarInline}>
          Guardar Ítem
        </button>
      </div>
    </form>
  )
}
